module.exports = __webpack_public_path__ + "img/QuantifiedESG_Logo_v3_White.0794bb64.png";